export interface GetReserveSetRequest {
  id: number
}

export function GetReserveSetRequestToJSON(value: GetReserveSetRequest): any {
  return {
    id: value.id !== 0 ? value.id : undefined
  }
}
